<template lang="pug">
extends order-layout-add-cell-base.pug
block content
    .list.inset
        .list-item.pointer(v-for="variant in variantList", :key="variant.id", @click="toggleItem(variant)")
            .list-left
                span.w-40.avatar
                    img(
                        :src="variant.product.media_urls.length > 0 ? variant.product.media_urls[0].s512 : '/img/slurp-500.png'",
                        v-if="variant.product != null"
                        alt="variant image"
                    )
            .list-body
                p.pull-right
                    i.material-icons.md-24(:class="{ 'item-checked': itemAdded(variant), 'text-muted': !itemAdded(variant) }") {{ itemAdded(variant) ? 'check_box' : 'check_box_outline_blank' }}
                span._400.block(v-if="variant.product != null") {{ variant.product.name }}
                span._500 {{ variant.name }} &nbsp;
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import addCellMixin from './mixins/order-layout-add-cell';

export default {
    mixins: [addCellMixin],

    computed: {
        ...mapGetters('variant', ['variantList', 'totalRecords']),

        options() {
            return this.variantList;
        },
    },

    created() {
        this.setItemType('variant');
        this.getVariants();
    },

    methods: {
        ...mapActions('variant', ['getVariantList']),

        getVariants() {
            this.startLoading('fetch-variants');

            let options = {
                query: this.query,
                relation: true,
                limit: this.pagination.perPage,
                page: this.pagination.page,
                outlet_id: this.orderLayout.outlet_id,
            };

            this.getVariantList(options).then(res => {
                this.endLoading('fetch-variants');
            });
        },

        fetchByQuery: _.debounce(function() {
            this.setPage(1);
            this.$refs.pagination.setPage(1);
            this.getVariants();
        }, 500),

        onPaginate(page) {
            this.setPage(page);
            this.getVariants();
        },
    },
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/franchise_component/order-layout/order-layout-add-variant.vue